import { services } from "@/mocks/homeData";
import { useInView } from "@/hooks/useInView";

export default function ServicesSection() {
  const { ref, inView } = useInView();

  return (
    <section id="services" ref={ref} className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 mb-14 md:mb-20 ${inView ? "animate-in" : "opacity-0"}`}>
          <div className="flex-1">
            <p className="text-secondary-600 text-xs md:text-sm font-medium tracking-widest uppercase mb-4">
              / 我们的服务
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              全方位数字化
              <br />
              解决方案
            </h2>
          </div>
          <div className="flex-1 max-w-md">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              从策略规划到技术实现，我们提供端到端的数字化服务。每一个项目都倾注了我们对技术与美学的极致追求。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service, idx) => (
            <div
              key={service.id}
              className={`group relative bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-colors duration-300 cursor-pointer ${
                inView ? `animate-in animate-in-delay-${idx + 1}` : "opacity-0"
              }`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
                  <i className={`${service.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}